import React from 'react';
import Header from '../components/Header';
import Announcements from '../components/Announcements';
import BookDetails from '../components/BookDetails';
import Footer from '../components/Footer';
import MailerLite from '../components/MailerLite';

// Import the background image
import backgroundImage from './nemia_new_web.png';  // Adjust the path based on your file structure


const Home = () => {
  return (
    <div class="container" style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom",
      minHeight: "100vh",
    }}>
      <Header />
      <main >
        <MailerLite />
        {/* actual content blocs go here */}

        <Announcements />
        <BookDetails />

        {/* end of content */}
      </main>
      <Footer />
  </div>
  )
};

export default Home;